import OnboardingType from "../../../../shared/onboarding/onboarding-type";
import { FETCH_ACTOR_OVERVIEW, UPDATE_ACTOR_SIGNED_RELEASE } from "./actions";

interface ActionState {
  actors: any[];
  loading: boolean;
  readOnly: boolean;
  onboardingSteps: OnboardingType[];
  errors: any;
  pristine: boolean;
}

export const OnboardingStep1ClassName = 'actor-overview-onboarding-step-1';
export const OnboardingStep2ClassName = 'actor-overview-onboarding-step-2';

const defaultState: ActionState = {
  actors: [],
  loading: true,
  readOnly: false,
  errors: null,
  pristine: true,
  onboardingSteps: [
    {
      target: '.' + OnboardingStep1ClassName,
      title: 'Actor Overview',
      content: `        
        <p>The percentage of actors who have signed a release.</p>        
      `
    },
    {
      target: '.' + OnboardingStep2ClassName,
      title: 'Actor Signed Release',
      content: `        
        <p>You can quickly mark an actor as having signed the release by clicking this icon.</p>        
      `
    }
  ]
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case FETCH_ACTOR_OVERVIEW + "_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null,
        pristine: true
      };
    }

    case FETCH_ACTOR_OVERVIEW + "_FULFILLED": {
      const sortedActors = action.payload.data.actors;
      sortByNumber(sortedActors);
      return {
        ...state,
        loading: false,
        errors: null,
        actors: sortedActors,
        actorsSignedReleasePercentage: action.payload.data.actorsSignedReleasePercentage,
        readOnly: action.payload.data.readOnly
      };
    }

    case FETCH_ACTOR_OVERVIEW + "_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: action.payload.response.errors
      };
    }

    case UPDATE_ACTOR_SIGNED_RELEASE + "_PENDING": {
      const { actor } = action.meta;
      const actors = Array.from(state.actors);
      const actorIndex = actors.findIndex(a => a.id == actor.id);
      if (actorIndex > -1) {
        actors[actorIndex].updating = true;
      }

      return {
        ...state,
        actors,
        errors: null
      };
    }

    case UPDATE_ACTOR_SIGNED_RELEASE + "_FULFILLED": {
      const { actor, signed } = action.meta;

      const actors = Array.from(state.actors);
      const actorIndex = actors.findIndex(a => a.id == actor.id);
      if (actorIndex > -1) {
        actors[actorIndex].signedRelease = signed;
        actors[actorIndex].updating = false;
      }

      return {
        ...state,
        actors,
        loading: false,
        errors: null,
        pristine: true
      };
    }

    case UPDATE_ACTOR_SIGNED_RELEASE + "_REJECTED": {
      const { actor } = action.meta;
      const actors = Array.from(state.actors);
      const actorIndex = actors.findIndex(a => a.id == actor.id);
      if (actorIndex > -1) {
        actors[actorIndex].updating = false;
      }
      return {
        ...state,
        actors,
        errors: action.payload.response.errors
      };
    }

    default:
      return state;
  }
};

const reorderActors = (list, sourceIndex, destinationIndex) => {
  const result: any[] = Array.from(list);
  result[sourceIndex].number = destinationIndex + 1;

  if (sourceIndex > destinationIndex) {
    for (let i = destinationIndex; i < sourceIndex; i++) {
      result[i].number++;
    }
  }

  if (sourceIndex < destinationIndex) {
    for (let i = sourceIndex + 1; i <= destinationIndex; i++) {
      result[i].number--;
    }
  }

  const [removed] = result.splice(sourceIndex, 1);
  result.splice(destinationIndex, 0, removed);

  return result;
};

export function sortByNumber(list) {
  list.sort((a, b) => {
    return a.number - b.number;
  });
}

export default reducer;
